import { Component } from '@builder.io/sdk';

const BUTTON_VARIANTS = ['primary', 'secondary', 'outlined-dark', 'outlined-light', 'text', 'alternate'];

export const config: Component = {
    name: 'Footer Hook SB',
    inputs: [
        {
            name: 'headline',
            type: 'string',
            required: true,
            defaultValue: 'Imagine your team with Storyblocks for Business',
        },
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: 'var(--color-blue-200, #bbdeff)',
        },
        {
            name: 'shadowVariant',
            type: 'boolean',
            onChange: (options) => {
                if (options.get('shadowVariant')) {
                    options.set('backgroundColor', 'var(--color-forest-200, #a7e2d2)');
                } else {
                    options.set('backgroundColor', 'var(--color-blue-200, #bbdeff)');
                }
            },
        },
        {
            name: 'shadowOptions',
            type: 'object',
            showIf: (options) => options.get('shadowVariant'),
            defaultValue: {
                shadowColor: 'var(--color-gray-100, #f5f5f5)',
                shadowImage: '',
            },
            subFields: [
                {
                    name: 'shadowColor',
                    type: 'color',
                },
                {
                    name: 'shadowImage',
                    type: 'file',
                    allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp'],
                },
            ],
        },
        {
            name: 'showCallToAction',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'callToAction',
            type: 'object',
            defaultValue: {
                text: 'Explore Footage',
                href: '/',
                variant: BUTTON_VARIANTS[5],
                size: 'default',
                target: '_self',
                rel: '',
            },
            showIf: (options) => options.get('showCallToAction'),
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    defaultValue: '',
                    required: true,
                },
                {
                    name: 'href',
                    type: 'string',
                    defaultValue: '/',
                    required: true,
                },
                {
                    name: 'target',
                    type: 'string',
                    enum: ['_self', '_blank', '_parent', '_top'],
                    helperText:
                        'For explanation of options, see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target',
                },
                {
                    name: 'variant',
                    type: 'string',
                    defaultValue: BUTTON_VARIANTS[5],
                    enum: BUTTON_VARIANTS,
                },
            ],
        },
        {
            name: 'dynamicContent',
            type: 'uiBlocks',
            defaultValue: {
                blocks: [],
            },
        },
    ],
};
